import { FC, Fragment } from "react";

import { useAlarmPaletteResolver } from "../../../hooks/use-alarm-color";

import { ChartWrapper } from "./styled";

export interface IVerticalBarChartProps {
  value: number;
  warningLevel: number;
  criticalLevel: number;
}

export const VerticalBarChart: FC<IVerticalBarChartProps> = props => {
  const { value, warningLevel, criticalLevel } = props;
  const resolveAlarmColor = useAlarmPaletteResolver();
  const lineY = (200 * value) / 100;

  const circleColor = resolveAlarmColor(value > warningLevel ? 30 : value > criticalLevel ? 60 : 90);
  const greenHeight = 200 - warningLevel * 2;
  const yellowHeight = 200 - greenHeight - criticalLevel * 2;

  return (
    <ChartWrapper>
      <svg width="80" height="150" viewBox="0 0 80 240">
        <rect x="30" y="5" width="30" height={greenHeight} fill={resolveAlarmColor(30)} opacity={0.8} />
        <rect x="30" y={greenHeight + 5} width="30" height={yellowHeight} fill={resolveAlarmColor(60)} opacity={0.8} />
        <rect
          x="30"
          y={greenHeight + yellowHeight + 5}
          width="30"
          height={criticalLevel * 2}
          fill={resolveAlarmColor(90)}
          opacity={0.8}
        />
        {[0, 20, 40, 60, 80, 100].map((value, index) => (
          <Fragment key={index}>
            <line x1="25" y1={205 - 2 * value} x2="65" y2={205 - 2 * value} stroke="gray" />
            <text x="20" y={209 - 2 * value} fontSize="10" textAnchor="end">
              {value}
            </text>
          </Fragment>
        ))}
        {value ? (
          <>
            <rect x="37.5" y={205 - lineY} width="15" height={lineY} fill="black" />
            <circle cx="45" cy="225" r="15" fill={circleColor} />
            <circle cx="45" cy="225" r="10" fill="white" />
            <text x="45" y="229" fontSize="10" textAnchor="middle" fontWeight={500}>
              {value}
            </text>
          </>
        ) : null}
      </svg>
    </ChartWrapper>
  );
};
